module.exports = __webpack_public_path__ + "static/img/h2-1.a7e0f92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/h2-1.png
// module id = xd+4
// module chunks = 1